var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgTrackingFilledRed = function SvgTrackingFilledRed(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FCE8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7797 6.96002C17.8802 6.74784 17.8365 6.49538 17.6704 6.32936C17.5044 6.16334 17.252 6.11961 17.0398 6.22012L6.48425 11.2201C6.27218 11.3206 6.1461 11.5434 6.16922 11.7769C6.19234 12.0104 6.35968 12.2042 6.58733 12.2611L10.7084 13.2914L11.7386 17.4125C11.7956 17.6401 11.9894 17.8075 12.2229 17.8306C12.4564 17.8537 12.6792 17.7276 12.7797 17.5155L17.7797 6.96002Z",
    fill: "#BD1A1D"
  })));
};
var Memo = /*#__PURE__*/memo(SvgTrackingFilledRed);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/TrackingFilledRed.4b54ee699953a32a7b4609b8ef94c316.svg";